import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { ConfigModule, RoutingConfig } from '@spartacus/core'
import { CmsPageGuard } from '@spartacus/storefront'
import { CustomRoutes } from '../models/enum/custom-routes.enum'
import { StyleGuideComponent } from '../styleguide/style-guide/style-guide.component'

const STATIC_ROUTES: Routes = [
  {
    path: 'style-guide',
    component: StyleGuideComponent,
    canActivate: [CmsPageGuard],
    data: { pageLabel: '/order' }
  }
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(STATIC_ROUTES),
    ConfigModule.withConfig({
      routing: {
        routes: {
          creditClaims: {
            paths: ['my-account/creditClaims']
          },
          creditClaim: {
            paths: ['my-account/creditClaim/:code']
          },
          order: {
            paths: ['my-account/order/:code']
          },
          createCreditClaim: {
            paths: ['my-account/createCreditClaim']
          },
          createCreditClaimOrder: {
            paths: ['my-account/createCreditClaimOrder/:orderCode', 'my-account/createCreditClaimOrder/']
          },
          rebateClaims: {
            paths: ['my-account/rebateClaims']
          },
          rebateClaim: {
            paths: ['my-account/rebateClaim/:code', 'my-account/rebateClaim']
          },
          createRebateClaim: {
            paths: ['my-account/createRebateClaim']
          },
          createDispenserAgreement: {
            paths: ['my-account/createDispenserAgreement']
          },
          dispenserAgreementDetails: {
            paths: ['my-account/dispenserAgreementDetails/:code']
          },
          dispenserAgreementShipmentHistory: {
            paths: ['my-account/dispenserAgreementShipmentHistory/:agreementCode']
          },
          dispenserAgreementShipmentDetails: {
            paths: ['my-account/dispenserAgreementShipmentDetails']
          },
          dispenserAgreementPlaceOrder: {
            paths: ['my-account/dispenserAgreementPlaceOrder/:code']
          },
          updateDispenserAgreement: {
            paths: ['my-account/updateDispenserAgreement/:code']
          },
          cancelDispenserAgreement: {
            paths: ['my-account/cancelDispenserAgreement/:code']
          },
          dispenserAgreements: {
            paths: ['my-account/dispenserAgreements']
          },
          newDispenserCreditRequest: {
            paths: ['my-account/newDispenserCreditRequest']
          },
          priceSupportAgreements: {
            paths: ['my-account/priceSupportAgreements']
          },
          priceSupportAgreementDetails: {
            paths: ['my-account/priceSupportAgreementDetails/:code']
          },
          product: {
            paths: ['product/:productCode/detail']
          },
          savedCarts: {
            paths: ['my-account/saved-carts']
          },
          'terms-of-use': {
            paths: ['terms-of-use']
          },
          login: {
            paths: ['sign-in'],
            protected: false,
            authFlow: true
          },
          loginForm: {
            paths: ['login'],
            protected: false,
            authFlow: true
          },
          [CustomRoutes.SHIPMENT_CREDIT_CLAIM]: {
            paths: ['my-account/shipmentCreditClaim']
          },
          [CustomRoutes.SHIPMENT_CREDIT_CLAIM_HISTORY]: {
            paths: ['my-account/shipmentCreditClaimHistory/:code']
          },
          [CustomRoutes.SHIPMENT_CREDIT_CLAIM_DETAIL]: {
            paths: ['my-account/shipmentCreditClaimDetail']
          },
          [CustomRoutes.ORDER_HISTORY]: {
            paths: ['my-account/orders']
          },
          [CustomRoutes.CART]: {
            paths: ['cart']
          }
        }
      }
    } as RoutingConfig)
  ],
  exports: [RouterModule]
})
export class CustomRoutingModule {}
